import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const ConnectionStatus = () => {
  const location = useLocation();
  const [hasShownWelcome, setHasShownWelcome] = useState(false);

  useEffect(() => {
    // Vérifier les paramètres d'URL pour les notifications de connexion
    const urlParams = new URLSearchParams(location.search);
    const googleLogin = urlParams.get('googleLogin');
    const userEmail = urlParams.get('email');
    const loginSuccess = urlParams.get('loginSuccess');
    const authMethod = urlParams.get('authMethod');
    const logout = urlParams.get('logout');

    // Notification de connexion Google réussie
    if (googleLogin === 'success' && userEmail && !hasShownWelcome) {
      toast.success(
        `🎉 Bienvenue ${userEmail} !\nVous êtes maintenant connecté avec Google`,
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "14px",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(212, 175, 55, 0.3)",
            color: "#2c1810",
          }
        }
      );
      setHasShownWelcome(true);
    }

    // Notification de connexion par email réussie
    if (loginSuccess === 'true' && authMethod === 'email' && !hasShownWelcome) {
      toast.success(
        "🎉 Connexion réussie !\nBienvenue sur Babouche Commerce",
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "14px",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(212, 175, 55, 0.3)",
            color: "#2c1810",
          }
        }
      );
      setHasShownWelcome(true);
    }

    // Notification de déconnexion
    if (logout === 'true') {
      toast.success(
        "👋 Vous avez été déconnecté avec succès !\nMerci de votre visite sur Babouche Commerce",
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: {
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "14px",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(212, 175, 55, 0.3)",
            color: "#2c1810",
          }
        }
      );
    }

    // Nettoyer l'URL après affichage des notifications
    if (googleLogin || loginSuccess || logout) {
      const newUrl = location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }, [location, hasShownWelcome]);

  // Ce composant ne rend rien visuellement, il gère juste les notifications
  return null;
};

export default ConnectionStatus;
